import {
  Box,
  OutlinedInput,
  styled
} from '@mui/material';
import { FONT_STYLE, THEME_COLORS } from '../../variables';

const QuantityInput = styled(OutlinedInput)(
  ({ hasproducttypes, variant }) => ({
    fontSize: '0.85rem',
    width:
      hasproducttypes === 'true'
        ? '68px'
        : variant === 'size'
          ? '28px'
          : '38px',
    height: variant === 'size' ? '20px' : '34px',
    borderRadius: 0,
    borderBottom:
      variant === 'size',
    '.MuiInputBase-input': {
      maxWidth: hasproducttypes === 'true' ? 'calc(100% - 30px)' : '100%',
      textAlign: ' center',
      padding: '0 !important'
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent !important'
    }
  })
);

const QuantityInputContainer = styled(Box)(
  ({ theme, isoutofstock, variant }) => ({
    position: 'relative',
    overflow: 'hidden',
    border: `1px solid ${THEME_COLORS.gray}`,
    borderRadius: variant === 'default' ? theme.shape.borderRadius : 0,
    borderBottom:
      isoutofstock === 'true' && variant === 'default'
        ? `2px solid ${THEME_COLORS.red}`
        : null
  })
);

const QuantitySelectorPrivateLabel = ({
                                        quantity,
                                        onQuantityChange,
                                        hasProductTypes = false,
                                        variant,
                                        label,
                                        stock,
                                        _isLoading
                                      }) => {
  return (
    <Box sx={{ display: 'grid', gap: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5
        }}
      >
        <QuantityInputContainer variant={variant}>
          {variant === 'size' && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '0.8rem',
                fontWeight: FONT_STYLE.semibold,
                paddingX: 0.25,
                height: '20px',
                color: 'white',
                backgroundColor: THEME_COLORS.primary
              }}
            >
              {label}
            </Box>
          )}
          <QuantityInput
            id="quantity-selector"
            inputProps={{
              maxLength: 4,
              max: 999 // ⬅️ Adiciona esta linha
            }}
            required
            value={quantity}
            hasproducttypes={hasProductTypes ? 'true' : 'false'}
            stock={stock}
            variant={variant}
            onChange={(e) => {
              const val = parseInt(e.target.value, 10);
              if (!isNaN(val)) {
                onQuantityChange?.(Math.min(val, 999));
              } else {
                onQuantityChange?.(0); // se apagar tudo ou for inválido
              }
            }}
          />

        </QuantityInputContainer>
      </Box>
    </Box>
  );
};

export default QuantitySelectorPrivateLabel;
